import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import { hasValidationErrors } from "../../../utils/validation-utils";
import { formatNetSalesPayload, formatNetSalesResponse, validateNetSalesPayload } from "../../utils/net-sales-utils";

export function useNetSalesNew() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [validationErrors, setValidationErrors] = useState({});

    const validateNetSales = values => {
        const errors = validateNetSalesPayload(values);

        setValidationErrors(errors);

        return errors;
    };

    async function createNetSales(segmentationId, payloadData) {
        const valuesToValidate = {
            ...payloadData,
            segmentation: segmentationId
        };

        const errors = validateNetSalesPayload(valuesToValidate);

        if (hasValidationErrors(errors)) {
            setValidationErrors(errors);
            setError(null);

            return {
                ok: false,
                reason: "validation",
                validationErrors: errors
            };
        }

        try {
            setLoading(true);
            setError(null);
            setValidationErrors({});

            const {
                accessToken,
                clientId
            } = getAuthParams();

            const body = formatNetSalesPayload(valuesToValidate);

            const requestOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "access_token": accessToken,
                    "client_id": clientId
                },
                body: JSON.stringify(body)
            };

            const response = await fetch(
                process.env.REACT_APP_ESSILOR_API +
                    `pacto-rebates-admin/v1/segmentacoes/${encodeURIComponent(segmentationId)}/objetivos`,
                requestOptions
            );

            if (!response.ok) {
                await throwResponseError(
                    response,
                    "Não foi possível salvar a meta Net Sales."
                );
            }

            const data = await response.json();

            const netSalesData = Array.isArray(data.resultado)
                ? data.resultado[0]
                : data.resultado || data;

            const formattedNetSales = formatNetSalesResponse(netSalesData);

            return {
                ok: true,
                netSales: formattedNetSales
            };
        } catch (requestError) {
            setError(requestError.message);

            return {
                ok: false,
                reason: "request",
                error: requestError.message
            };
        } finally {
            setLoading(false);
        }
    }

    return {
        loading,
        error,
        validationErrors,
        validateNetSales,
        createNetSales
    };
}